module.exports = __webpack_public_path__ + "ath_game_web/img/4.3.0fac4d9f.png";